var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogosGoogleGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1025_46402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43213 23.8822V11.5825L3.64244 8.09279L0.244141 6.15625V21.7116C0.244141 22.9126 1.21087 23.8822 2.40059 23.8822H7.43213Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6816 23.8821H29.7132C30.9065 23.8821 31.8696 22.9089 31.8696 21.7115V6.15625L28.0205 8.37432L24.6816 11.5824V23.8821Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43364 11.5813L6.91797 6.77545L7.43364 2.17578L16.0592 8.68737L24.6847 2.17578L25.2615 6.52712L24.6847 11.5813L16.0592 18.0929L7.43364 11.5813Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6816 2.17662V11.5821L31.8696 6.1559V3.26185C31.8696 0.577703 28.8255 -0.952453 26.6944 0.657288L24.6816 2.17662Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.244141 6.15596L3.55003 8.65171L7.43213 11.5822V2.17668L5.41937 0.657345C3.28454 -0.95252 0.244141 0.577759 0.244141 3.26178V6.15583V6.15596Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1025_46402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6271,
    height: 24,
    fill: "white",
    transform: "translate(0.244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGoogleGmail);
export default __webpack_public_path__ + "static/media/logos_google-gmail.4bce36e713d1d8b60bae5878031b844a.svg";
export { ForwardRef as ReactComponent };